"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Sharpness = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M20.5,6 C20.8747431,6 21.1311071,6.38801682 20.9184848,6.77362468 L12.4184848,19.7736247 C12.2903464,20.0456303 11.7895346,20.1176682 11.5815152,19.7736247 L3.08151519,6.77362468 C2.89501961,6.50040089 3.03960373,6 3.5,6 L20.5,6 Z M19.5756837,7 L4.42431633,7 L12,18.5863397 L19.5756837,7 Z M17.5,8 L12,16.5 L12,8 L17.5,8 Z" })));
};
Sharpness.displayName = 'Sharpness';
exports.default = Sharpness;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Sharpness.js.map